import { useNavigate } from "react-router-dom";

import { PageContainer } from "@/features/ui";

import { useAuth } from "@/features/authentication";
import { PurchaseOrderForm } from "@/features/purchase-orders/purchase-order-form";
import { apiOutletClient, getErrorMessage } from "@/features/shared";
import { useSnackbar } from "@/features/ui";

import { Button } from "@mui/material";

export const CreatePurchaseOrder = () => {
  const { outlet } = useAuth();
  const navigate = useNavigate();
  const { showSnackbar } = useSnackbar();

  const handleSubmit = async (formData) => {
    try {
      const { buyerId, ...payload } = formData;

      await apiOutletClient.post("purchase-orders/standard", payload, {
        headers: {
          "Outlet-Id": buyerId,
        },
      });
      navigate(-1);
    } catch (error) {
      showSnackbar(getErrorMessage(error));
    }
  };

  return (
    <PageContainer
      maxWidth="xl"
      title="Buat Pesanan Pembelian Bulk"
      breadcrumbs={[
        { title: "Pesanan Pembelian", path: "/procurement/purchase-orders/standard" },
        { title: "Tambah" },
      ]}
    >
      <PurchaseOrderForm
        onSubmit={handleSubmit}
        defaultValues={{
          buyer: outlet,
        }}
        renderActionButton={({ isSubmitting }) => (
          <Button
            type="submit"
            variant="contained"
            loading={isSubmitting}
          >
            Tambah
          </Button>
        )}
      />
    </PageContainer>
  );
};
